import React from 'react';
import './Chef.css';

function Chef() {
  return <div>Chef</div>;
}

export default Chef;
